module.exports = __webpack_public_path__ + "img/Youtube.46b93009.svg";